<template>
  <div class="header-container text-center">
    <div
      class="background-img"
      :class="{ 'no-description': !item.metadata.artDescription }"
      :style="backgroundImage"
    />
    <b-container class="header-row">
      <b-avatar v-if="hasImage" class="mb-4 p-2" :src="item.thumbnail" size="5rem" />
      <b-row>
        <b-col md="6" class="link-title">
          <Icon class="invert" icon="arrow" color="black" :width="iconSize" :height="iconSize" />
          <nuxt-link :to="$trailingSlash(localePath('collections'))"> {{ name }}</nuxt-link>
          <h1 class="title">{{ item.title }}</h1>
        </b-col>
        <b-col md="6">
          <p class="art-description mb-4">
            {{ item.metadata.artDescription }}
          </p>
          <h2 class="description mb-4">
            {{ item.description }}
          </h2>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import Icon from 'UI/Icon';
import { mapState } from 'vuex';

export default {
  components: { Icon },
  props: {
    item: {
      type: Object,
      default: function () {
        return {
          thumbnail: 'https://cdn.vexels.com/img/header-icon.svg',
          name: '',
          description: ''
        };
      }
    },
    name: {
      type: String,
      required: true,
      default: ''
    },
    hasImage: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      iconSize: 13
    };
  },
  computed: {
    ...mapState('collections', ['collectionContent']),
    backgroundImage() {
      const img = this.item.header || this.collectionContent[0]?.image;
      return {
        background: `linear-gradient(0, white ${
          this.item.metadata.artDescription ? 15 : 35
        }%, #FFF0 100%), 
        url('${img}') no-repeat center center/cover`
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.header-container {
  justify-content: center;
  display: flex;
  overflow: hidden;
  position: relative;
  width: 100%;
  min-height: 220px;
  .background-img {
    opacity: 0.3;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 320px;
    filter: blur(5px);
    @include sm {
      height: 500px;
    }
    &.no-description {
      @include sm {
        height: 300px;
      }
    }
  }
  .header-row {
    max-width: 1200px;
    text-align: left;
    margin-top: 48px;
    @include xl2 {
      max-width: 900px;
    }
    @include sm {
      margin-top: 24px;
    }
    .art-description {
      font-size: 19px;
      color: #6d6d6d;
    }
    .description {
      font-size: 16px;
      font-weight: 400;
      color: #212529;
    }
    .link-title {
      a {
        font-size: 18px;
        color: #000;
      }
      .title {
        font-size: 35px;
        margin-top: 10px;
      }
    }
  }
  p {
    font-size: 16px;
  }
}
</style>
